import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="py-4 border-t border-white/5 bg-[#132440] px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            {/* Brand */}
            <Link to="/" className="flex items-center gap-2.5 group">
              <img src="/images/logo.png" alt="logo" className="w-auto h-16" />
            </Link>

            {/* Compact Links */}
            <div className="flex flex-wrap justify-center gap-x-8 gap-y-3">
              {[
                { label: "Contact Us", to: "/contact" },
                { label: "Privacy Policy", to: "/privacy" },
                { label: "Terms of Use", to: "/terms" },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-slate-500 hover:text-indigo-400 text-xs font-bold uppercase tracking-[0.15em] transition-colors duration-200"
                >
                  {link.label}
                </Link>
              ))}
            </div>

            {/* Socials & Legal */}
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="hidden md:block w-[1px] h-4 bg-white/10" />
              <p className="text-slate-700 text-[10px] font-black uppercase tracking-[0.3em] whitespace-nowrap">
                © 2026 MsnbcNew
              </p>
            </div>
          </div>

          {/* Mobile Copyright */}
          <p className="text-slate-800 text-[9px] font-black uppercase tracking-[0.3em] text-center mt-8 md:hidden">
            © 2026 AarpGames
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
